<div class="activities-wrapper">
  <!-- Botones de acción principales -->
  <div class="action-buttons">
    <button nz-button nzType="default" nzShape="round" (click)="onCreateActivity()" class="btn-action">
      <app-st-icon class="text-header-16 cursor-pointer" style="margin-right: 8px" name="pending_actions"
        [bold]="true"></app-st-icon>
      Programar actividad
    </button>

    <button nz-button
            nzType="default"
            nzShape="round"
            (click)="onSendEmail()"
            class="btn-action">
      <app-st-icon class="text-header-16 cursor-pointer" style="margin-right: 8px" name="sticky_note_2"
                   [bold]="true"></app-st-icon>
      Enviar mensaje
    </button>
  </div>

  <!-- Contenedor scrollable para las secciones -->
  <div class="sections-scrollable">
    <!-- Loading general mientras se cargan las actividades -->
    <div *ngIf="loadingActivities" class="loading-container">
      <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
      <p class="loading-text">Cargando actividades...</p>
    </div>

    <!-- Contenido cuando no está cargando -->
    <div *ngIf="!loadingActivities">
      <!-- Sección de Actividades (solo pendientes) -->
      <div class="section-container" *ngIf="hasPendingActivities">
        <div class="section-divider collapse-header" (click)="pendingCollapsed = !pendingCollapsed">
          <span class="divider-line"></span>
          <app-st-icon class="collapse-icon"
            [name]="pendingCollapsed ? 'keyboard_arrow_right' : 'keyboard_arrow_down'"></app-st-icon>
          <span class="section-label">Actividades pendientes</span>
          <span class="pill">{{ pendingCount }}</span>
          <span class="divider-line"></span>
        </div>

        <div *ngIf="!hasPendingActivities" class="no-activities">
          <app-st-icon name="event_busy" style="font-size: 48px; color: #ccc; margin-bottom: 16px"></app-st-icon>
          <p class="text-label-14 text-grey-7">No hay actividades pendientes</p>
        </div>

        <div class="activities-list-container" *ngIf="hasPendingActivities">
          <div *ngIf="!pendingCollapsed">
            <div class="activities-date-section" *ngFor="let group of pendingActivitiesGrouped">
              <div class="activities-date-divider">
                <span class="divider-line"></span>
                <span class="date-label">{{ group.label }}</span>
                <span class="divider-line"></span>
              </div>
              <div class="activities-count">
                {{ group.activities.length }}
                {{ group.activities.length === 1 ? 'actividad' : 'actividades' }}
              </div>

              <div class="activity-card" *ngFor="let activity of group.activities; trackBy: trackActivity">
                <div class="activity-icon-wrapper" [ngClass]="activityIconWrapperClass(activity)">
                  <app-st-icon [name]="activityIcon(activity)" [style.font-size]="'20px'"
                    [style.color]="activityIconColor(activity)"></app-st-icon>
                </div>
                <div class="activity-content">
                  <div class="activity-header">

                    <span class="activity-title">{{ activity.activityType?.name || 'Actividad' }}</span>
                    <span class="activity-time">{{ activityTime(activity) }}</span>
                  </div>
                  <div>
                    <span class="activity-title" *ngIf="activity.summary"
                      [innerHTML]="sanitizeHtml(activity.summary)"></span>
                    <p *ngIf="activity.note" class="activity-description">
                      {{ activity.note }}
                    </p>
                  </div>
                  <p *ngIf="activity.dateDeadLine" class="activity-due-date">
                    Vence: {{ activityDueDate(activity) }}
                    <span *ngIf="activity.hasExpired" class="expired-badge">
                      <app-st-icon name="warning" style="font-size: 14px; margin-right: 4px;"></app-st-icon>
                      Vencida
                    </span>
                  </p>
                  <div class="activity-footer">
                    <div class="activity-assignee">
                      <nz-avatar [nzText]="userInitials(activity)" [nzSize]="24"
                        style="background-color: #f0f0f0; color: #333; font-size: 10px"></nz-avatar>
                      <span class="assignee-name">{{ userFullName(activity) }}</span>
                    </div>
                    <span class="activity-status" [ngClass]="activityStatusClass(activity.state)">
                      {{ activityStatusLabel(activity.state) }}
                    </span>
                  </div>
                  <div class="activity-actions">
                    <button
                      *ngIf="activity.state !== 'Done' && activity.state !== 'Cancelled' && ((activity.userId === loggedUser?.id || activity.user?.id === loggedUser?.id) || loggedUser?.roleId === 1)"
                      nz-button nzType="text" nzSize="small" (click)="onMarkDone(activity)">
                      <app-st-icon name="done_all" style="margin-right: 4px"></app-st-icon>
                      Marcar como hecho
                    </button>
                    <button nz-button nzType="text" nzSize="small" (click)="onEditActivity(activity)">
                      <app-st-icon name="edit" style="margin-right: 4px"></app-st-icon>
                      Editar
                    </button>
                    <button *ngIf="activity.state !== 'Cancelled'" nz-button nzType="text" nzSize="small"
                      (click)="onCancelActivity(activity)">
                      <app-st-icon name="close" style="margin-right: 4px"></app-st-icon>
                      Cancelar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sección de Historial (actividades no pendientes) -->
      <div class="section-container" *ngIf="hasHistoryActivities">
        <div class="section-divider collapse-header" (click)="historyCollapsed = !historyCollapsed">
          <span class="divider-line"></span>
          <app-st-icon class="collapse-icon"
            [name]="historyCollapsed ? 'keyboard_arrow_right' : 'keyboard_arrow_down'"></app-st-icon>
          <span class="section-label">Historial</span>
          <span class="pill">{{ historyCount }}</span>
          <span class="divider-line"></span>
        </div>
        <div class="section-content">
          <div *ngIf="!hasHistoryActivities" class="no-messages">
            <p class="text-label-14 text-grey-7" style="margin: 0; text-align: center; padding: 20px 0;">
              No hay actividades en el historial.
            </p>
          </div>

          <div *ngIf="hasHistoryActivities && !historyCollapsed" class="activities-list-container">
            <div class="activities-date-section" *ngFor="let group of historyActivitiesGrouped">
              <div class="activities-date-divider">
                <span class="divider-line"></span>
                <span class="date-label">{{ group.label }}</span>
                <span class="divider-line"></span>
              </div>
              <div class="activities-count">
                {{ group.activities.length }}
                {{ group.activities.length === 1 ? 'actividad' : 'actividades' }}
              </div>

              <div class="activity-card" *ngFor="let activity of group.activities; trackBy: trackActivity">
                <div class="activity-icon-wrapper" [ngClass]="activityIconWrapperClass(activity)">
                  <app-st-icon [name]="activityIcon(activity)" [style.font-size]="'20px'"
                    [style.color]="activityIconColor(activity)"></app-st-icon>
                </div>
                <div class="activity-content">
                  <div class="activity-header">

                    <span class="activity-title">{{ activity.activityType?.name || 'Actividad' }}</span>
                    <span class="activity-status" [ngClass]="activityStatusClass(activity.state)">
                      {{ historyStatus(activity) }}
                    </span>
                  </div>
                  <div>
                    <span class="activity-title" *ngIf="activity.summary"
                      [innerHTML]="sanitizeHtml(activity.summary)"></span>
                    <p *ngIf="activity.note" class="activity-description">
                      {{ activity.note }}
                    </p>
                  </div>

                  <p *ngIf="activity.dateDeadLine" class="activity-due-date">
                    Vence: {{ activityDueDate(activity) }}
                    <span *ngIf="activity.hasExpired" class="expired-badge">
                      <app-st-icon name="warning" style="font-size: 14px; margin-right: 4px;"></app-st-icon>
                      Vencida
                    </span>
                  </p>
                  <div class="activity-footer">
                    <div class="activity-assignee">
                      <nz-avatar [nzText]="userInitials(activity)" [nzSize]="24"
                        style="background-color: #f0f0f0; color: #333; font-size: 10px"></nz-avatar>
                      <span class="assignee-name">{{ activity.user?.partner?.name || 'Sin asignar' }}</span>
                    </div>
                  </div>
                  <p *ngIf="activity.doneNote" class="activity-description"
                    style="font-style: italic; color: #666; white-space: pre-line; word-break: break-word; max-width: 90%;">
                    "{{ activity.doneNote }}"
                  </p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sección de Mensajes -->
      <div class="section-container" *ngIf="hasSentMessages">
        <div class="section-divider collapse-header" (click)="noteCollapsed = !noteCollapsed">
          <span class="divider-line"></span>
          <app-st-icon class="collapse-icon"
            [name]="noteCollapsed ? 'keyboard_arrow_right' : 'keyboard_arrow_down'"></app-st-icon>
          <span class="section-label">Mensajes enviados</span>
          <span class="pill">{{ sentMessagesCount }}</span>
          <span class="divider-line"></span>
        </div>
      </div>
    </div>
  </div>
  <!-- Fin del contenedor scrollable -->

  <!-- Chat siempre visible debajo -->
  <div *ngIf="showChat" class="chat-container">
    <app-chat [chatName]="chatName" [isLarge]="true" [chat]="opportunity?.chat"></app-chat>
  </div>
</div>
